export default __webpack_public_path__ + "static/media/swirls.6cb06eea.svg";